import React, { useState, useEffect } from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
  RadioGroup,
  Radio,
  FormControl,
  Typography,
  Accordion,
  Grid,
  Box,
  Button,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditLevel8(props) {
  const [open, setOpen] = useState(false);
  const [level8, setLevel8] = React.useState({
    isNatural: props.product.isNatural,
    isHerbal: props.product.isHerbal,
    isTraditional: props.product.isTraditional,
    discontinue: props.product.discontinue,
    barcode: props.product.barcode,
    isOnlineSell: props.product.isOnlineSell,
    isSuspend: props.product.isSuspend,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.fire) {
      Validation8();
    }
  }, [props.fire]);

  return (
    <Accordion
      expanded={props.expanded === "panel8"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        onClick={() => props.setExpanded("panel8")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography>مرحله هشتم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از اتمام ویرایش محصول اطمینان دارید ؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => props.setFire(true)}
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setOpen(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={isSmall ? 12 : 3}>
              <TextField
                sx={{ direction: "rtl" }}
                id="outlined-basic"
                size="small"
                fullWidth
                value={level8.barcode ? level8.barcode : ""}
                label="بارکد محصول"
                variant="outlined"
                onChange={(evt) => {
                  if (evt.target.value) {
                    setLevel8({
                      ...level8,
                      barcode: evt.target.value,
                    });
                  } else {
                    setLevel8({
                      ...level8,
                      barcode: null,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={isSmall ? 0 : 9}></Grid>
            <Grid item xs={isSmall ? 12 : 3}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(level8.isNatural)}
                      value={level8.isNatural}
                      onChange={(evt) => {
                        setLevel8({
                          ...level8,
                          isNatural: evt.target.checked,
                        });
                      }}
                    />
                  }
                  label="محصول فرآورده طبیعی است ."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={isSmall ? 12 : 3}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(level8.isHerbal)}
                      value={level8.isHerbal}
                      onChange={(evt) => {
                        setLevel8({
                          ...level8,
                          isHerbal: evt.target.checked,
                        });
                      }}
                    />
                  }
                  label="محصول  گیاهی است ."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={isSmall ? 12 : 3}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(level8.isTraditional)}
                      value={level8.isTraditional}
                      onChange={(evt) => {
                        setLevel8({
                          ...level8,
                          isTraditional: evt.target.checked,
                        });
                      }}
                    />
                  }
                  label="محصول  طب سنتی است ."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(level8.discontinue)}
                      value={level8.discontinue}
                      onChange={(evt) => {
                        setLevel8({
                          ...level8,
                          discontinue: evt.target.checked,
                        });
                      }}
                    />
                  }
                  label="تولید محصول متوقف شده است."
                />
              </FormGroup>
            </Grid>

            <Grid item xs={isSmall ? 12 : 3}>
              <FormControl>
                <FormLabel
                  color="secondary"
                  sx={{ fontWeight: "bold" }}
                  id="demo-radio-buttons-group-label"
                >
                  فروش آنلاین :
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={level8.isOnlineSell}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="دارد"
                    onChange={(evt) => {
                      setLevel8({
                        ...level8,
                        isOnlineSell: JSON.parse(evt.target.value),
                      });
                    }}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="ندارد"
                    onChange={(evt) => {
                      setLevel8({
                        ...level8,
                        isOnlineSell: JSON.parse(evt.target.value),
                      });
                    }}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={isSmall ? 12 : 3}>
              <FormControl>
                <FormLabel
                  color="secondary"
                  sx={{ fontWeight: "bold" }}
                  id="demo-radio-buttons-group-label"
                >
                  تعلیق محصول :
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={level8.isSuspend}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="تعلیق"
                    onChange={(evt) => {
                      setLevel8({
                        ...level8,
                        isSuspend: JSON.parse(evt.target.value),
                      });
                    }}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="عدم تعلیق"
                    onChange={(evt) => {
                      setLevel8({
                        ...level8,
                        isSuspend: JSON.parse(evt.target.value),
                      });
                    }}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              props.setExpanded("panel7");
            }}
          >
            مرحله قبل
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            اتمام
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  function Validation8() {
    setTimeout(function () {
      props.fill(level8);
    }, 1000);
  }
}
